import { createBrowserRouter } from 'react-router-dom';
import { defaultRoutes } from './config';

const router = createBrowserRouter(defaultRoutes);

export default router;
